import React from "react";
import "../Styles/Service.css";
import "../assets/css/flaticon.css";
import "../Styles/Theme.css";
import "../assets/css/custom-animation.css";
import businesAutomation from "../assets/icons/busines-automation.png";
import controlPanel from "../assets/icons/control-panel.png";
import mobileApps from "../assets/icons/mobile-apps.png";
import softwareDevelopment from "../assets/icons/software-development.png";
import resource from "../assets/icons/resource.png";
import { Link } from "react-router-dom";
import config from "../config";
const Service = () => {
  return (
    <div>
      <section className="bd-service-area main-top-service pt-80 pb-50 gray-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 pt-20">
              <div className="bd-section-title-wrapper mb-50">
                <h5 className="bd-section-subtitle mb-15 subtitle-without-border">
                  What We Offer
                </h5>
                <h2 className="bd-section-title" style={{fontSize:"38px"}}>
                  Ambrella's Services are{" "}
                  <span style={{ color: "#098FB4" }}>bi-fold</span>
                </h2>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="bd-service mb-30">
                <div className="bd-service-icon mb-20 serviceResOne">
                  <i>
                    <img src={businesAutomation} />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20 serviceH4">
                  <Link to={`${config.appurl}services#domain-services`}>
                    Domain Consultancy Services
                  </Link>
                </h4>
                <p className="ServicePOne">
                  Ambrella brings deep domain experience delivered via flexible
                  consulting models to conceptualize, embed and leverage digital
                  transformation in the fabric of your enterprise.{" "}
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="bd-service mb-30">
                <div className="bd-service-icon mb-20 serviceResOne">
                  <i>
                    <img src={controlPanel} />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20 serviceH4">
                  <Link to={`${config.appurl}services#it-services`}>IT Engineering Services</Link>
                </h4>
                <p className="ServicePOne">
                  Helping enterprises build, operate and maintain Data, Logic,
                  Network and Integration assets in Data Stores, Apps and APIs
                  in Cloud/Hybrid environments.
                </p>
              </div>
            </div>
            {/* <div className="col-lg-4 col-md-6">
              <div className="bd-service mb-30">
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src={softwareDevelopment} />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <Link to={"/custom-software-development"}>
                    Custom Software Development
                  </Link>
                </h4>
                <p>
                  With our expertise, we develop tailor-made software that fits
                  your unique needs, helping to streamline operations and drive
                  growth faster.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="bd-service mb-30">
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src={mobileApps} />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <Link to={"/mobile-apps-development"}>
                    Mobile Apps Development
                  </Link>
                </h4>
                <p>
                  We offer end-to-end mobile app development services to help
                  you maximise your business potential.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="bd-service mb-30">
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src={resource} />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <Link to={"/website-development"}>
                    Website Development
                  </Link>
                </h4>
                <p>
                  In the Canadian business scene, website development covers
                  creating and managing online platforms, including design,
                  coding, and performance optimization to boost digital growth.
                </p>
              </div>
            </div> */}
            {/* <div className="col-lg-4 col-md-6">
              <div className="bd-service mb-30">
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659451034/website/icons/dedicate-resource-icon_rr9dis.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <Link to={"/hire-a-resource"}>Dedicate Resource</Link>
                </h4>
                <p>
                  Experience the true value of time and money by hiring a dedicated resource that allows you to focus on the projects you care about.
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Service;
